import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import {
  allUsersSelector,
  currentFactorySelector,
  isAdminSelector,
  membershipsForCurrentFactorySelector,
} from '../selectors';
import {
  createMembershipInCurrentFactory,
  deleteCurrentFactory,
  deleteFactoryMembership,
  updateCurrentFactory,
  updateCurrentFactoryBackgroundImage,
} from '../actions/entry';
import Factory from '../components/Factory';

const mapStateToProps = (state) => {
  const allUsers = allUsersSelector(state);
  const isAdmin = isAdminSelector(state);
  const { name, background, backgroundImage } = currentFactorySelector(state);
  const memberships = membershipsForCurrentFactorySelector(state);

  return {
    name,
    background,
    backgroundImage,
    memberships,
    allUsers,
    isEditable: isAdmin,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      onUpdate: updateCurrentFactory,
      onBackgroundImageUpdate: updateCurrentFactoryBackgroundImage,
      onDelete: deleteCurrentFactory,
      onMembershipCreate: createMembershipInCurrentFactory,
      onMembershipDelete: deleteFactoryMembership,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(Factory);
